import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import IconButton from 'components/common/IconButton';
import { numberFormatter } from 'helpers/utils';

const BulAction = ({ onDrawSurroundingProperties }) => {
  return (
    <>
      <Row className="flex-between-center mb-3">
        <Col sm="auto" className="ms-auto text-end ps-0">
          <IconButton
            variant="falcon-default"
            size="sm"
            icon="plus"
            transform="shrink-3"
            className="me-2"
            onClick={() => onDrawSurroundingProperties(5)}
          >
            <span className="d-none d-sm-inline-block ms-1">New</span>
          </IconButton>
        </Col>
      </Row>
    </>
  );
};

BulAction.propTypes = {
  onDrawSurroundingProperties: PropTypes.func
};

const SurroundingPropertiesTable = ({ onDrawSurroundingProperties }) => {
  const { surroundingProperties } = useSelector(
    state => state.livingCarbonGrant
  );
  const [data, setData] = useState([]);

  const columns = [
    {
      accessorKey: 'id',
      header: 'Id',
      meta: {
        headerProps: { className: 'text-900' }
      }
    },
    {
      accessorKey: 'area',
      header: 'Est. Area (ha)',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { area } = original;
        return numberFormatter(area, 2);
      }
    }
  ];

  useEffect(() => {
    setData(surroundingProperties);
  }, [surroundingProperties]);

  const table = useAdvanceTable({
    data,
    columns,
    sortable: true,
    selection: false,
    pagination: true,
    perPage: 5,
    selectionColumnWidth: 30
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <BulAction onDrawSurroundingProperties={onDrawSurroundingProperties} />
        <AdvanceTable
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            striped: true,
            className: 'fs-10 mb-0 overflow-hidden'
          }}
        />
      </AdvanceTableProvider>
    </>
  );
};

SurroundingPropertiesTable.propTypes = {
  onDrawSurroundingProperties: PropTypes.func
};

export default SurroundingPropertiesTable;
